/**
 * Retrieve & set environment variables (process.env)
 */
import fs from 'fs';
import path from 'path';
const dotenv = require('dotenv');
const Online = process.env.NODE_ENV === 'production';

export default function environmentVariables(): void {
    /**
     * .env files to search for
     * - ORDER BY LOWEST PRIORITY; last in line will overwrite the reset
     */
    const env_files = ['.env'];

    //  Environment-dependent .env files
    if (!Online) {
        env_files.unshift('../microservices/.env', '../../../.env', '../../.env', '../.env');
    }

    //  Add to process.env
    for (const file of env_files) {
        try {
            const filepath = path.join(process.cwd(), file);

            //  accessSync will throw if file doesn't exist
            fs.accessSync(filepath);

            dotenv.config({ path: filepath });

            //  We can stack multiple .env files atop each other; don't break if found
        } catch (e) {
            //  do nothing
        }
    }

    /**
     * .env.private files
     * - ORDER BY HIGHEST PRIORITY; we'll quit after the first one
     */
    const private_env_files = ['.env.private'];

    //  Environment-dependent .env files
    if (!Online) {
        private_env_files.push(
            '../.env.private',
            '../../.env.private',
            '../../../.env.private',
            '../microservices/.env.private'
        );
    }

    //  Add to process.env
    for (const file of private_env_files) {
        try {
            const filepath = path.join(process.cwd(), file);

            //  accessSync will throw if file doesn't exist
            fs.accessSync(filepath);

            //  Set env vars – will only write if env. vars have not yet been set
            //  --> Which is why we overwrite below
            dotenv.config({ path: filepath });

            //  Overwrite current env. vars
            const env_vars = dotenv.parse(fs.readFileSync(filepath));
            for (const k in env_vars) {
                process.env[k] = env_vars[k];
            }

            //  Break having found the first .env.private file
            break;
        } catch (e) {
            //  do nothing
        }
    }
}
